





































































































































import {
  defineComponent,
  computed,
  watch,
  reactive,
  ref,
} from '@vue/composition-api';
import _ from 'lodash';
import { useRouter } from '@ideavivat/vivat-2';
import { useQuery, useResult, useMutation } from '@vue/apollo-composable';

import useAuth from '@/useAuth';

import getUser from '@/gql/usersSetting/getUser.gql';
import createUser from '@/gql/usersSetting/createUser.gql';
import updateUser from '@/gql/usersSetting/updateUser.gql';
import checkInformationExists from '@/gql/usersSetting/checkInformationExists.gql';
import getHubs from '@/gql/company/getHubs.gql';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonDropzoneWithAvatarUpload from '@/components/User/CommonDropzoneWithAvatarUpload.vue';

const UserEditor = defineComponent({
  components: {
    CommonModalWithPreset,
    CommonDropzoneWithAvatarUpload,
  },
  props: {
    id: { type: [Number, String], default: -1 },
  },
  setup(props: any, { emit }: any) {
    const { route } = useRouter();
    const { me } = useAuth();
    const avatarPath = ref('');
    const _avatarPath = computed(() => {
      // const isUrlAbsolute = (url: string) => (url.indexOf('://') > 0 || url.indexOf('//') === 0);
      // if (avatarPath.value === null || !(isUrlAbsolute(avatarPath.value))) {
      //   console.warn('[PageColumnWithUserEditor] Avatar path is implemented in incorrect format or it is not exist. Fallback to default cute Aya avatar!');
      //   return '/avatar.png';
      // }
      // return avatarPath.value;
    });

    const getHubsResult = (data: any) => data.me.company.hubs.data;

    const form: { [key: string]: any } = reactive({
      name: '',
      email: '',
      employeeCode: '',
      username: '',
      telephone: '',
      password: '',
      confirmPassword: '',
      roleId: '',
      hub: null,
    });

    const userInput = computed(() => ({
      id: props.id === -1 ? undefined : props.id,
      name: form.name,
      email: form.email,
      active: true,
      employeeCode: form.employeeCode,
      username: props.id === -1 ? form.username : undefined,
      password: form.password !== '' ? form.password : undefined,
      companyId: props.id === -1 ? me.company.id : undefined,
      hub: form.hub ? { connect: form.hub.id } : undefined,
      roles: props.id === -1 ? {
        connect: route.value.params.initRole ? [route.value.params.initRole] : [form.roleId],
      } : undefined,
    }));

    const createUserMutation = useMutation(createUser, () => ({
      variables: {
        input: userInput.value,
      },
      refetchQueries: ['getUsers'],
    }));
    const updateUserMutation = useMutation(updateUser, () => ({
      variables: {
        input: userInput.value,
      },
      refetchQueries: ['getUsers'],
    }));

    const computedMutation = computed(() => {
      if (props.id !== -1) return updateUserMutation;
      return createUserMutation;
    });

    const { result: getUserResult, loading: userLoading } = useQuery(getUser, computed(() => ({
      id: props.id,
    })), () => ({
      fetchPolicy: 'network-only',
    }));
    const userResult = useResult(getUserResult, {}, (data) => data.user);
    watch(() => userResult.value, (newVal, oldVal) => {
      if (props.id !== -1 && !userLoading.value && newVal !== oldVal) {
        form.name = userResult.value.name;
        form.employeeCode = userResult.value.employeeCode;
        form.email = userResult.value.email;
        form.password = '';
        form.confirmPassword = '';
        form.roleId = userResult.value.roles[0].id;
        form.hub = userResult.value.hub;
      }
    });

    const confirmModal = ref(null);
    createUserMutation.onDone(() => {
      (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'สำเร็จ' });
    });
    updateUserMutation.onDone(() => {
      emit('done');
      (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'สำเร็จ' });
    });
    const errorModal = ref(null);
    createUserMutation.onError(() => {
      (errorModal.value as any).compose();
    });
    updateUserMutation.onError(() => {
      emit('error');
      (errorModal.value as any).compose();
    });

    // =================================================
    //  THIS PART USE TO VALIDATE EMAIL & TELEPHONE NO.
    // =================================================
    const mutation = useMutation(checkInformationExists);

    const failedValidatedEmailRule = ref('');
    const failedValidatedTelephoneRule = ref('');
    const failedValidatedUsernameRule = ref('');

    const checkUserInformation = _.debounce(() => {
      mutation.mutate({
        email: form.email,
        userId: props.edit || -1,
        username: form.username,
      });
    }, 300);

    watch(() => form.email, (newVal, oldVal) => {
      if (newVal !== oldVal) checkUserInformation();
    });

    watch(() => form.username, (newVal, oldVal) => {
      if (newVal !== oldVal) checkUserInformation();
    });

    mutation.onDone((response: any) => {
      if (response.data.checkExistsInformation.status === 'allow') {
        failedValidatedEmailRule.value = '';
        failedValidatedUsernameRule.value = '';
      }
      if (response.data.checkExistsInformation.status === 'email already exists') failedValidatedEmailRule.value = `excluded:${form.email}`;
      if (response.data.checkExistsInformation.status === 'username already exists') failedValidatedUsernameRule.value = `excluded:${form.username}`;
    });
    // ==================================================

    return {
      _avatarPath,
      avatarPath,
      form,
      computedMutation,

      confirmModal,
      errorModal,

      // ==== Use to validate email & username
      failedValidatedEmailRule,
      failedValidatedUsernameRule,

      getHubs,
      getHubsResult,
    };
  },
});

export default UserEditor;
